import { createAction, props } from '@ngrx/store';
import {
  EmailToViewModel,
  UserConfigViewModel,
} from 'src/app/shared/models/autogenerated';

export const loadUserConfig = createAction(
  '[Global Settings] Load User Config'
);

export const updateUserConfig = createAction(
  '[Global Settings] Update User Config'
);

export const setUserConfig = createAction(
  '[Global Settings] Set User Config',
  props<{
    userConfig: UserConfigViewModel;
  }>()
);

export const setUserConfigIsEmailDisabled = createAction(
  '[Global Settings] Set User Config Is Email Disabled',
  props<{
    isEmailDisabled: boolean;
  }>()
);

export const loadHasUserGlobalAdminAccess = createAction(
  '[Global Settings] Load User Global Admin Access'
);

export const setHasUserGlobalAdminAccess = createAction(
  '[Global Settings] Set User Global Admin Access',
  props<{
    hasUserGlobalAdminAccess: boolean;
  }>()
);

export const loadAllGlobalAdminsAccess = createAction(
  '[Global Settings] Load All Global Admin Access'
);

export const setAllGlobalAdminsAccess = createAction(
  '[Global Settings] Set All Global Admin Access',
  props<{ globalAdminsIds: string[] }>()
);

export const loadAllExceptionsAccess = createAction(
  '[Global Settings] Load All Exception Access'
);

export const setAllExceptionsAccess = createAction(
  '[Global Settings] Set All Exception Access',
  props<{ exceptionsIds: string[] }>()
);

export const sendReleaseEmail = createAction(
  '[Global Settings] Send Release Email',
  props<{
    role: string;
  }>()
);

export const sendReleaseEmailSuccess = createAction(
  '[Global Settings] Send Release Email Success',
  props<{ result: EmailToViewModel }>()
);

export const clearReleaseEmailResult = createAction(
  '[Global Settings] Clear Release Email Response'
);
